import { render, staticRenderFns } from "./FirmFilesTable.vue?vue&type=template&id=23928904&scoped=true"
import script from "./FirmFilesTable.vue?vue&type=script&lang=js"
export * from "./FirmFilesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23928904",
  null
  
)

export default component.exports